export type PickerType = 'winner' | 'scorer';

/** Viewport width breakpoints for the FuturesCard responsive layout. */
export const FUTURES_CARD_NARROW_WIDTH = 420;
export const FUTURES_CARD_TIGHT_WIDTH = 360;

/**
 * Scorer `SoccerKit` size on the futures card — also drives `pickCardMedia` min-height
 * so the media column does not reserve extra blank space under the kit/trophy.
 */
export const FUTURES_CARD_SCORER_KIT_SIZE = {
  TIGHT: 60,
  NARROW: 68,
  DEFAULT: 76,
} as const;

export function getFuturesCardScorerKitSize(isTight: boolean, isNarrow: boolean): number {
  if (isTight) return FUTURES_CARD_SCORER_KIT_SIZE.TIGHT;
  if (isNarrow) return FUTURES_CARD_SCORER_KIT_SIZE.NARROW;
  return FUTURES_CARD_SCORER_KIT_SIZE.DEFAULT;
}

export const FUTURES_CARD_COPY = {
  WINNER_LABEL: 'Winner',
  TOP_SCORER_LABEL: 'Top scorer',
  PICK_TEAM: 'Pick a team',
  PICK_PLAYER: 'Pick a player',
  PICK_OTHER_PLAYER_LABEL: 'Other',
  MODAL_WINNER: 'Tournament winner',
  MODAL_SCORER: 'Top scorer',
  LOCKED_CAPTION: 'Locked — tournament has started',
  /** TalkBack / VoiceOver hint when the pick is tappable */
  A11Y_PICK_DOUBLE_TAP: 'Double tap to choose',
} as const;
